module.exports = __webpack_public_path__ + "images/x-white-47633bcb.svg";